import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Layout from './components/Layout';
import Users from './components/Users';
import AppUsers from './components/AppUsers';
import CallLogs from './components/CallLogs';
import HistoricalCallLogs from './components/HistoricalCallLogs';
import SipDomains from './components/SipDomains';
import CallRates from './components/CallRates';
import Settings from './components/Settings';
import DepositAdmin from './components/DepositAdmin';
import DepositManagement from './components/DepositManagement';
import DepositOrdersAdmin from './components/DepositOrdersAdmin';
import WithdrawalRequest from './components/WithdrawalRequest';
// WithdrawalHistory component ကို ဖယ်ရှားခြင်း
import WithdrawalAdmin from './components/WithdrawalAdmin';
import Merchants from './components/Merchants';
import Login from './components/Login';
import Unauthorized from './components/Unauthorized';
import ProtectedRoute from './components/ProtectedRoute';
import Profile from './components/Profile';
import CallPage from './components/CallPage';
import { AuthProvider } from './context/AuthContext';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/call" element={<CallPage />} />
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route 
            path="users" 
            element={
              <ProtectedRoute adminOnly={true}>
                <Users />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="app-users" 
            element={<AppUsers />}
          />
          <Route path="call-logs" element={<CallLogs />} />
          <Route path="historical-call-logs" element={<HistoricalCallLogs />} />
          <Route path="sip-domains" element={<SipDomains />} />
          <Route path="call-rates" element={<CallRates />} />
          <Route 
            path="deposit-admin" 
            element={<DepositAdmin />}
          />
          <Route 
            path="transaction-history" 
            element={<DepositManagement />}
          />
          <Route 
            path="deposit-orders"
            element={<DepositOrdersAdmin />}
          />
          {/* Withdrawal Routes */}
          <Route 
            path="withdrawal-request"
            element={<WithdrawalRequest />}
          />
          {/* withdrawal-history route ကို ဖယ်ရှားခြင်း */}
          <Route 
            path="withdrawal-admin"
            element={<WithdrawalAdmin />}
          />
          <Route 
            path="merchants" 
            element={
              <ProtectedRoute adminOnly={true}>
                <Merchants />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="settings" 
            element={
              <ProtectedRoute adminOnly={true}>
                <Settings />
              </ProtectedRoute>
            } 
          />
          <Route path="profile" element={<Profile />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
